import { MessageCircle } from "lucide-react";

export default function FloatingWhatsApp({ phone, message, testId }) {
    const url =
        "https://wa.me/" +
        phone.replace(/\D/g, "") +
        "?text=" +
        encodeURIComponent(message);

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={testId || "floating-whatsapp"}
            aria-label="Cotizar por WhatsApp"
            className="fixed bottom-6 right-6 z-40 inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebd5b] text-white shadow-2xl shadow-[#25D366]/40 transition-all hover:scale-105 active:scale-95"
            style={{
                boxShadow:
                    "0 8px 24px -4px rgba(37, 211, 102, 0.5), 0 0 0 0 rgba(37, 211, 102, 0.4)",
                animation: "wa-pulse 2.5s ease-in-out infinite",
            }}
        >
            <MessageCircle className="w-7 h-7" strokeWidth={2} />
            <style>{`
                @keyframes wa-pulse {
                    0%, 100% { box-shadow: 0 8px 24px -4px rgba(37, 211, 102, 0.5), 0 0 0 0 rgba(37, 211, 102, 0.4); }
                    50% { box-shadow: 0 8px 24px -4px rgba(37, 211, 102, 0.5), 0 0 0 14px rgba(37, 211, 102, 0); }
                }
            `}</style>
        </a>
    );
}
